import React, { useEffect, useState } from 'react';

import Scheduler, { Resource } from 'devextreme-react/scheduler'
import type { SchedulerTypes } from 'devextreme-react/scheduler';

import ResourceCell from './ResourceCell'
import axios from 'axios';
import apiUrl from '../../../configs/constant'
import { useToast } from '../../../components/ToastProvider'
import ActivityTooltip from './ActivityTooltip';

const currentDate = new Date()
const views: SchedulerTypes.ViewType[] = ['month'];

export default function KalenderSalesman() {
    const { showToast } = useToast()
    const { token } = JSON.parse(localStorage.getItem('user')!)

    const [listData, setListData] = useState<any[]>([])
    const [listEmployees, setListEmployees] = useState<any[]>([])

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = () => {
        axios
            .get(`${apiUrl.apiUrl}/omni/kalender/get-data-non-sales`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(({ data }) => {
                if (!data.success) return showToast(data.message, 'error')

                setListData(data.data)
                setListEmployees(data.employees)
            })
            .catch(() => showToast('Gagal mengambil data kalender', 'error'))
    }

    return (
        <Scheduler
            timeZone="America/Los_Angeles"
            dataSource={listData}
            views={views}
            defaultCurrentView="month"
            defaultCurrentDate={currentDate}
            height={730}
            startDayHour={9}
            appointmentTooltipComponent={({ data }) => (
                <ActivityTooltip
                    item={data?.appointmentData}
                />
            )}
            editing={{
                allowAdding: false,
                allowDeleting: false,
                allowUpdating: false,
                allowDragging: false,
                allowResizing: false
            }}
            onAppointmentDblClick={(e) => (e.cancel = true)}
            onAppointmentFormOpening={(e) => (e.cancel = true)}
        >
            <Resource
                label="Employee"
                fieldExpr="employeeID"
                valueExpr="id"
                dataSource={listEmployees}
                allowMultiple={false}
            />
        </Scheduler>

    )
}